import { render, staticRenderFns } from "./MarketSetting.vue?vue&type=template&id=128c9005"
import script from "./MarketSetting.vue?vue&type=script&lang=js"
export * from "./MarketSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports